import React, { useState } from 'react';

const AdminQuestion = ({
    onDashboard,
    onCourseManagement,
    onChapterManagement,
    onQuestionBank,
    onStudentDirectory,
    onParentDirectory,
    onRevenue,
    onLogout
}) => {
    const [isDarkMode, setIsDarkMode] = useState(false);

    const toggleDarkMode = () => {
        setIsDarkMode(!isDarkMode);
        document.documentElement.classList.toggle('dark');
    };

    return (
        <>
            <style>
                {`
                .material-symbols-outlined {
                    font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
                    vertical-align: middle;
                    display: inline-block;
                    line-height: 1;
                    text-transform: none;
                    letter-spacing: normal;
                    word-wrap: normal;
                    white-space: nowrap;
                    direction: ltr;
                }
                ::-webkit-scrollbar {
                    width: 5px;
                }
                ::-webkit-scrollbar-track {
                    background: transparent;
                }
                ::-webkit-scrollbar-thumb {
                    background: rgba(203, 213, 225, 0.5);
                    border-radius: 10px;
                }
                .dark ::-webkit-scrollbar-thumb {
                    background: rgba(51, 65, 85, 0.5);
                }
                ::-webkit-scrollbar-thumb:hover {
                    background: rgba(148, 163, 184, 0.8);
                }
                .dark ::-webkit-scrollbar-thumb:hover {
                    background: rgba(71, 85, 105, 0.8);
                }
                scrollbar-width: thin;
                scrollbar-color: rgba(203, 213, 225, 0.5) transparent;
                `}
            </style>

            <div className={`fixed inset-0 flex overflow-hidden font-sans antialiased ${isDarkMode ? 'dark bg-[#0F172A] text-slate-100' : 'bg-[#F8FAFC] text-slate-900'}`}>
                {/* Sidebar */}
                <aside className="w-64 bg-[#131C2E] text-slate-300 flex-shrink-0 flex flex-col border-r border-slate-800 hidden lg:flex h-full">
                    <div className="p-6 flex items-center gap-3 shrink-0">
                        <div className="w-10 h-10 bg-[#00A669] rounded-lg flex items-center justify-center text-white font-bold text-xl uppercase tracking-tighter shadow-lg shadow-emerald-500/20">H</div>
                        <div>
                            <h1 className="text-white font-bold leading-tight">Master Admin</h1>
                            <p className="text-[10px] text-slate-500 uppercase tracking-widest font-semibold text-nowrap">System Management</p>
                        </div>
                    </div>

                    <nav className="flex-1 px-4 space-y-1 mt-4 overflow-y-auto custom-scrollbar">
                        <button
                            onClick={onDashboard}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">dashboard</span>
                            <span className="font-medium group-hover:text-white transition-colors">Dashboard Overview</span>
                        </button>

                        <div className="pt-4 pb-2 px-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest">Core Content</div>
                        <button
                            onClick={onCourseManagement}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">auto_stories</span>
                            <span className="font-medium group-hover:text-white transition-colors">Course Management</span>
                        </button>
                        <button
                            onClick={onChapterManagement}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">account_tree</span>
                            <span className="font-medium group-hover:text-white transition-colors">Chapter Management</span>
                        </button>
                        <button
                            onClick={onQuestionBank}
                            className="w-full bg-[#00A669] text-white flex items-center gap-3 px-4 py-3 rounded-xl transition-all shadow-md shadow-emerald-500/20 text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl">quiz</span>
                            <span className="font-medium">Question Bank</span>
                        </button>

                        <div className="pt-6 pb-2 px-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest">Directories</div>
                        <button
                            onClick={onStudentDirectory}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">group</span>
                            <span className="font-medium group-hover:text-white transition-colors">Student Directory</span>
                        </button>
                        <button
                            onClick={onParentDirectory}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">family_restroom</span>
                            <span className="font-medium group-hover:text-white transition-colors">Parent Directory</span>
                        </button>

                        <div className="pt-6 pb-2 px-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest">Reports</div>
                        <button
                            onClick={onRevenue}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">monitoring</span>
                            <span className="font-medium group-hover:text-white transition-colors">Revenue/Analytics</span>
                        </button>




                    </nav>

                    <div className="p-4 mt-auto border-t border-slate-800 shrink-0">
                        <button
                            onClick={onLogout}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-rose-400 hover:bg-rose-500/10 transition-all group"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl">logout</span>
                            <span className="font-medium group-hover:translate-x-1 transition-transform">Sign Out</span>
                        </button>
                    </div>
                </aside>

                {/* Main Content Area */}
                <div className="flex-1 flex flex-col min-w-0 h-full overflow-hidden">
                    {/* Header */}
                    <header className="h-16 bg-white dark:bg-[#1E293B] border-b border-slate-200 dark:border-slate-800 flex items-center justify-between px-8 sticky top-0 z-20 shrink-0 shadow-sm">
                        <div className="flex-1 max-w-xl">
                            <div className="relative">
                                <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">search</span>
                                <input
                                    className="w-full bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg pl-10 pr-4 py-2 focus:ring-[#00A669] focus:border-[#00A669] transition-all text-sm outline-none text-slate-700 dark:text-slate-200"
                                    placeholder="Search questions, subjects or topics..."
                                    type="text"
                                />
                            </div>
                        </div>
                        <div className="flex items-center gap-6 ml-6">
                            <button className="relative text-slate-500 dark:text-slate-400 hover:text-[#00A669] transition-colors flex items-center">
                                <span className="material-symbols-outlined">notifications</span>
                                <span className="absolute top-0 right-0 w-2 h-2 bg-rose-500 rounded-full border-2 border-white dark:border-[#1E293B]"></span>
                            </button>
                            <div className="h-8 w-[1px] bg-slate-200 dark:bg-slate-700"></div>
                            <div className="flex items-center gap-3">
                                <div className="text-right hidden sm:block">
                                    <p className="text-sm font-semibold dark:text-white">Admin Profile</p>
                                    <p className="text-[10px] text-slate-500 font-bold uppercase tracking-tight">Super Administrator</p>
                                </div>
                                <div className="w-10 h-10 rounded-full bg-slate-100 dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 overflow-hidden shadow-sm">
                                    <img alt="Admin Avatar" className="w-full h-full object-cover" src="https://lh3.googleusercontent.com/aida-public/AB6AXuB_RLrWS6EwBazBnSQG5_DHFfXALJfYg9wsfMW2fPBEUgyM8X72ZCm3tlqpialTVYycHghgR294Gsrna7Md-Y9BvMy9mxyIOvqFuj8_YHzdBVxVI2U40W2yQq21BtKRTS6sIsuf-Yp954VMbmBsiyidj0IifV9SqpurFlj0TzEkyVoievlPd5qy98srI15ENSq6h760WxEMEp8ZODu-efso3LH0phGIQADhqq71tFNmvHA8-ImYHsI7eorpZHeD2nlfdjDp1fPs5MM" />
                                </div>
                            </div>
                        </div>
                    </header>

                    {/* Scrollable Content */}
                    <main className="flex-1 overflow-y-auto p-8 space-y-8 bg-background-light dark:bg-[#0F172A] pb-24">
                        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
                            <div>
                                <h2 className="text-3xl font-bold tracking-tight text-slate-900 dark:text-white">Question Bank Repository</h2>
                                <p className="text-slate-500 dark:text-slate-400 mt-1">Manage and curate global assessment content for the learning ecosystem.</p>
                            </div>
                            <div className="flex items-center gap-3">
                                <button className="px-5 py-2.5 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-[#1E293B] text-slate-600 dark:text-slate-300 font-semibold text-sm hover:bg-slate-50 dark:hover:bg-slate-800 transition-all flex items-center gap-2 shadow-sm">
                                    <span className="material-symbols-outlined text-[20px]">upload_file</span>
                                    Bulk Upload
                                </button>
                                <button className="px-5 py-2.5 rounded-lg bg-[#00A669] text-white font-semibold text-sm hover:bg-opacity-90 shadow-lg shadow-emerald-500/20 transition-all flex items-center gap-2">
                                    <span className="material-symbols-outlined text-[20px]">add</span>
                                    Create New
                                </button>
                            </div>
                        </div>

                        {/* Filters */}
                        <div className="bg-white dark:bg-[#1E293B] rounded-2xl border border-slate-100 dark:border-slate-800 shadow-sm overflow-hidden">
                            <div className="p-6 border-b border-slate-100 dark:border-slate-800 flex flex-wrap items-center gap-4">
                                <div className="flex-1 min-w-[200px]">
                                    <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-1.5 ml-1">Filter by Subject</label>
                                    <select className="w-full bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg py-2 px-3 text-sm focus:ring-[#00A669] focus:border-[#00A669] outline-none text-slate-700 dark:text-slate-200">
                                        <option>All Subjects</option>
                                        <option>Mathematics</option>
                                        <option>Physics</option>
                                        <option>Computer Science</option>
                                        <option>Biology</option>
                                    </select>
                                </div>
                                <div className="flex-1 min-w-[200px]">
                                    <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-1.5 ml-1">Filter by Topic</label>
                                    <select className="w-full bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg py-2 px-3 text-sm focus:ring-[#00A669] focus:border-[#00A669] outline-none text-slate-700 dark:text-slate-200">
                                        <option>All Topics</option>
                                        <option>Algebra</option>
                                        <option>Quantum Mechanics</option>
                                        <option>Data Structures</option>
                                        <option>Cell Division</option>
                                    </select>
                                </div>
                                <div className="flex-none pt-5">
                                    <button className="px-4 py-2 text-[#00A669] font-semibold text-sm hover:bg-emerald-500/5 rounded-lg transition-colors">Clear All Filters</button>
                                </div>
                            </div>

                            <div className="overflow-x-auto">
                                <table className="w-full text-left border-collapse min-w-[800px]">
                                    <thead>
                                        <tr className="bg-slate-50/50 dark:bg-slate-800/50 border-b border-slate-100 dark:border-slate-800">
                                            <th className="px-6 py-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest">Question Details</th>
                                            <th className="px-6 py-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest">Type</th>
                                            <th className="px-6 py-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest">Subject / Topic</th>
                                            <th className="px-6 py-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest">Difficulty</th>
                                            <th className="px-6 py-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest text-right">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
                                        {[
                                            { q: 'What is the primary function of DNA polymerase III in prokaryotic replication?', id: '#QB-10452', author: 'Dr. Sarah Jenkins', type: 'MCQ', subject: 'Biology', topic: 'Molecular Genetics', diff: 'Hard', diffColor: 'rose' },
                                            { q: 'Explain the difference between Quick Sort and Merge Sort.', id: '#QB-10453', author: 'Alan Turing', type: 'Short Answer', subject: 'Computer Science', topic: 'Algorithms', diff: 'Medium', diffColor: 'amber' },
                                            { q: 'The value of π is approximately ______.', id: '#QB-10454', author: 'Admin', type: 'Fill-in-blanks', subject: 'Mathematics', topic: 'Geometry', diff: 'Easy', diffColor: 'emerald' },
                                            { q: 'Newton\'s second law states that Force equals Mass times ______.', id: '#QB-10455', author: 'Prof. Richard', type: 'Fill-in-blanks', subject: 'Physics', topic: 'Mechanics', diff: 'Easy', diffColor: 'emerald' },
                                        ].map((row, idx) => (
                                            <tr key={idx} className="hover:bg-slate-50/50 dark:hover:bg-slate-800/30 transition-colors group">
                                                <td className="px-6 py-5">
                                                    <div className="max-w-md">
                                                        <p className="font-medium text-sm text-slate-900 dark:text-white line-clamp-1 group-hover:text-[#00A669] transition-colors">{row.q}</p>
                                                        <p className="text-[11px] text-slate-400 mt-0.5">ID: {row.id} • Created by {row.author}</p>
                                                    </div>
                                                </td>
                                                <td className="px-6 py-5">
                                                    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-semibold border ${row.type === 'MCQ' ? 'bg-blue-50 text-blue-700 border-blue-100 dark:bg-blue-500/10 dark:text-blue-400 dark:border-blue-500/20' :
                                                        row.type === 'Short Answer' ? 'bg-purple-50 text-purple-700 border-purple-100 dark:bg-purple-500/10 dark:text-purple-400 dark:border-purple-500/20' :
                                                            'bg-amber-50 text-amber-700 border-amber-100 dark:bg-amber-500/10 dark:text-amber-400 dark:border-amber-500/20'
                                                        }`}>
                                                        <span className="material-symbols-outlined text-[14px]">
                                                            {row.type === 'MCQ' ? 'checklist' : row.type === 'Short Answer' ? 'short_text' : 'edit_note'}
                                                        </span>
                                                        {row.type}
                                                    </span>
                                                </td>
                                                <td className="px-6 py-5">
                                                    <div className="text-xs">
                                                        <p className="font-semibold text-slate-700 dark:text-slate-300">{row.subject}</p>
                                                        <p className="text-slate-400">{row.topic}</p>
                                                    </div>
                                                </td>
                                                <td className="px-6 py-5">
                                                    <span className={`px-2.5 py-1 rounded-full text-[11px] font-bold uppercase tracking-wider border ${row.diffColor === 'rose' ? 'bg-rose-50 text-rose-700 border-rose-100 dark:bg-rose-500/10 dark:text-rose-400 dark:border-rose-500/20' :
                                                        row.diffColor === 'amber' ? 'bg-amber-50 text-amber-700 border-amber-100 dark:bg-amber-500/10 dark:text-amber-400 dark:border-amber-500/20' :
                                                            'bg-emerald-50 text-emerald-700 border-emerald-100 dark:bg-emerald-500/10 dark:text-emerald-400 dark:border-emerald-500/20'
                                                        }`}>
                                                        {row.diff}
                                                    </span>
                                                </td>
                                                <td className="px-6 py-5 text-right">
                                                    <div className="flex items-center justify-end gap-2">
                                                        <button className="p-2 text-slate-400 hover:text-[#00A669] transition-colors"><span className="material-symbols-outlined">edit</span></button>
                                                        <button className="p-2 text-slate-400 hover:text-rose-500 transition-colors"><span className="material-symbols-outlined">delete</span></button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="p-6 border-t border-slate-100 dark:border-slate-800 flex items-center justify-between">
                                <p className="text-xs text-slate-500">Showing <span className="font-bold text-slate-900 dark:text-white">1-4</span> of <span className="font-bold text-slate-900 dark:text-white">1,248</span> questions</p>
                                <div className="flex items-center gap-2">
                                    <button className="p-2 rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800 text-slate-400 disabled:opacity-50" disabled>
                                        <span className="material-symbols-outlined">chevron_left</span>
                                    </button>
                                    <button className="px-3 py-1.5 rounded-lg bg-[#00A669] text-white text-xs font-bold shadow-md shadow-emerald-500/20">1</button>
                                    <button className="px-3 py-1.5 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-800 text-slate-600 dark:text-slate-400 text-xs font-bold transition-colors">2</button>
                                    <button className="px-3 py-1.5 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-800 text-slate-600 dark:text-slate-400 text-xs font-bold transition-colors">3</button>
                                    <button className="p-2 rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800 text-slate-400">
                                        <span className="material-symbols-outlined">chevron_right</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Footer */}
                        <footer className="py-8 border-t border-slate-200 dark:border-slate-800 flex flex-col sm:flex-row items-center justify-between text-slate-400 text-[10px] font-bold uppercase tracking-widest gap-4">
                            <div className="flex items-center gap-2">
                                <div className="w-6 h-6 bg-[#00A669] rounded flex items-center justify-center text-white text-[10px] font-bold">H</div>
                                <span>© 2024 Himigo Platform - Master Admin Console</span>
                            </div>
                        </footer>
                    </main>
                </div>

                {/* Dark Mode Toggle Float */}
                <button
                    onClick={toggleDarkMode}
                    className="fixed bottom-6 right-6 w-12 h-12 rounded-full bg-white dark:bg-[#1E293B] border border-slate-200 dark:border-slate-700 shadow-xl shadow-slate-200/50 dark:shadow-none flex items-center justify-center text-slate-600 dark:text-slate-300 z-[60] hover:scale-110 active:scale-95 transition-all"
                >
                    <span className="material-symbols-outlined">{isDarkMode ? 'light_mode' : 'dark_mode'}</span>
                </button>
            </div>
        </>
    );
};

export default AdminQuestion;
